import {
  cardPartCss,
  matchesBreakpoint,
  mediaCss,
  paneGridCss,
  revealAbstractCss,
} from '../surface';

import type { ArmSpec } from '../armRegistry';

export const twoColumnIndex: ArmSpec = {
  stamp: (ctx) => {
    if (ctx.cards().length === 0) return { render_state: 'fallback' };

    return {
      render_state: matchesBreakpoint('wide') ? 'rendered' : 'partial',
    };
  },

  onReady: (ctx) => {
    if (ctx.cards().length === 0) return;

    ctx.injectStyles(
      paneGridCss(ctx.scope, { columns: 2, gap: '16px 32px', band: 'wide' }) +
        mediaCss(
          'wide',
          revealAbstractCss(ctx.scope, 5) +
            cardPartCss('thumbnail', ctx.scope, 'display: none;'),
        ),
    );
  },
};
